module.exports = __webpack_public_path__ + "fonts/MyTypeOfFont-A5Bg.2c1f769.ttf";